import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  label: string;
}

export const LabeledSeparator: React.FC<Props> = ({ label }) => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <div className="border-t border-t-gray-200 border-dashed" />
      <div className="flex items-center justify-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
        <p className="mb-1 text-sm bg-white">{t(label)}</p>
      </div>
    </div>
  );
};
